module.exports = __webpack_public_path__ + "static/media/linkedin.7ccb7a06.png";